import { baseApiV2 } from '@verantos-dev/app-state-base';
import { type ListResponse, type ObjectResponse } from '@verantos-dev/types-common';
import {
  type ProjectDetail,
  type CreateProjectWithDatasetData,
  type DeleteProjectData,
  type ProjectCRUDResponse,
} from '@verantos-dev/types-projects';

import { PROJECTS_BASE_PATH } from './constants';

export const projectApiSlice = baseApiV2
  .enhanceEndpoints({
    addTagTypes: ['projects'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getProjects: builder.query<ListResponse<ProjectDetail>, string | null>({
        query: (urlParams: string) => {
          const params = urlParams ? `${encodeURI(urlParams)}` : '';
          return `/${PROJECTS_BASE_PATH}/${params}`;
        },
        providesTags: ['projects'],
      }),

      getProject: builder.query<ObjectResponse<ProjectDetail>, string>({
        query: (id: string) => `/${PROJECTS_BASE_PATH}/${id}`,
        providesTags: ['projects'],
      }),

      createProject: builder.mutation<ProjectCRUDResponse, CreateProjectWithDatasetData>({
        query: (data) => ({
          url: `/${PROJECTS_BASE_PATH}/`,
          method: 'POST',
          body: { ...data },
        }),
        invalidatesTags: ['projects'],
      }),

      deleteProject: builder.mutation<ProjectCRUDResponse, DeleteProjectData>({
        query: ({ projectId }) => ({
          url: `/${PROJECTS_BASE_PATH}/${projectId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['projects'],
      }),
    }),
  });
export const {
  useGetProjectsQuery,
  useGetProjectQuery,
  useCreateProjectMutation,
  useDeleteProjectMutation,
} = projectApiSlice;
